module.exports = __webpack_public_path__ + "static/media/01-galeria-05-louis-vuitton@2x.7912351e.jpg";